import { URLSearchParams } from 'url';

import _isNil from 'lodash/isNil';

export const convertParamToObject = <T = any>(urlSearchParam: URLSearchParams): T => {
  // if (!urlSearchParam) {
  //   return null;
  // }

  const entries = urlSearchParam.entries() as any;
  const result: any = {};

  for (const [key, value] of entries) {
    result[key] = value;
  }

  return result;
};

export const buildQueries = (params: any) => {
  let requestString = '';
  Object.keys(params).forEach((key) => {
    if (!_isNil(params[key]) && params[key] !== '') {
      requestString += `${key}=${params[key]}&`;
    }
  });

  return requestString;
};

export const trimQueryData = (payload: any) => {
  if (!payload) {
    return payload;
  }

  let searchData = { ...payload };

  Object.keys(searchData).forEach((item) => {
    if (typeof searchData[item] === 'string') searchData[item] = searchData[item]?.trim();
  });

  return searchData;
};
